import { Dropdown } from 'react-bootstrap';
import Input from '../../../components/bootstrap/forms/Input';
import Icon from '../../../components/icon/Icon';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import SubHeader, {
	SubHeaderLeft,
	SubHeaderRight,
	SubheaderSeparator,
} from '../../../layout/SubHeader/SubHeader';
import { DropdownMenu, DropdownToggle } from '../../../components/bootstrap/Dropdown';
import Button from '../../../components/bootstrap/Button';
import Popovers from '../../../components/bootstrap/Popovers';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Checks, { ChecksGroup } from '../../../components/bootstrap/forms/Checks';
import Card, {
	CardActions,
	CardBody,
	CardHeader,
	CardLabel,
	CardTitle,
} from '../../../components/bootstrap/Card';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api_getOrders, api_getOrdersByFilter } from '../../../api/order';
const PAGE_SIZE = 10;

const AllOrder = () => {
	const [order, setOrder] = useState<any>([]);
	const [loading, setLoading] = useState(false);
	const [pageNo, setPageNo] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const navigate = useNavigate();
	const [filter, setFilter] = useState(false);
	const [searchString, setSearchString] = useState('');

	const getOrder = async () => {
		if (loading) return;
		try {
			setLoading(true);
			const res = await api_getOrders(pageNo, PAGE_SIZE);
	
			if (res.isSuccess) {
				if (!res.data.length) {
					setHasMore(false);
					return;
				}
				setOrder([...order, ...res.data]);
				setPageNo(pageNo + 1);
			}
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	const getOrdersByFilter = async () => {
		if (loading) return;
		setFilter(true);
		setOrder([]);
		try {
			setLoading(true);
			const res = await api_getOrdersByFilter(searchString);
	
			if (res.isSuccess) {
				if (!res.data.length) {
					setHasMore(false);
					return;
				}
				setOrder(res.data);
			}
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	const onLoadMore = () => {
		if (hasMore) {
			getOrder();
		}
	};

	useEffect(() => {
		getOrder();
	}, []);

	return (
		<PageWrapper title={'Order'}>
			<div style={{ marginTop: '20px' }}>
				<SubHeader>
					<SubHeaderLeft>
						<label
							className='border-0 bg-transparent cursor-pointer me-0'
							htmlFor='searchInput'>
							<Icon
								icon='Search'
								size='2x'
								color='primary'
								onClick={() => {
									setOrder([]);
									setHasMore(true);
									getOrdersByFilter();
								}}
							/>
						</label>
						<Input
							value={searchString}
							onChange={(e: any) => setSearchString(e?.target?.value)}
							id='searchInput'
							type='search'
							className='border-0 shadow-none bg-transparent'
							placeholder='Search orders...'
						/>
					</SubHeaderLeft>
					<SubHeaderRight>
						<Dropdown>
							<DropdownToggle hasIcon={false}>
								<Button
									icon='FilterAlt'
									color='dark'
									isLight
									className='btn-only-icon position-relative'>
									<Popovers desc='Filtering applied' trigger='hover'>
										<span className='position-absolute top-0 start-100 translate-middle badge border border-light rounded-circle bg-danger p-2'>
											<span className='visually-hidden'>
												there is filtering
											</span>
										</span>
									</Popovers>
								</Button>
							</DropdownToggle>
							<DropdownMenu isAlignmentEnd size='lg'>
								<div className='container py-2'>
									<div className='row g-3'>
										<FormGroup label='Order Filter' className='col-12'>
											<ChecksGroup>
												<Checks
													key='1'
													id=''
													label='Active'
													name='Active'
													value={'true'}
												/>
												<Checks
													key='2'
													id=''
													label='Price(low to high)'
													name='Payment'
													value={'false'}
												/>
												<Checks
													key='2'
													id=''
													label='Price(high to low)'
													name='Payment'
													value={'false'}
												/>
												<Checks
													key='3'
													id=''
													label='Ratings'
													name='Ratings'
													value={'Ratings'}
												/>
											</ChecksGroup>
										</FormGroup>
									</div>
								</div>
							</DropdownMenu>
						</Dropdown>
						<SubheaderSeparator />
					</SubHeaderRight>
				</SubHeader>
			</div>
			<Card stretch>
				<CardHeader borderSize={1}>
					<CardLabel icon='Alarm' iconColor='info'>
						<CardTitle>All Order</CardTitle>
					</CardLabel>
					<CardActions>
						<Button
							icon='PersonAdd'
							onClick={() => navigate('/add/order')}
							color='primary'
							isLight={true}>
							New Order
						</Button>
					</CardActions>
				</CardHeader>
				<CardBody isScrollable className='table-responsive'>
					<table className='table table-modern'>
						<thead>
							<tr>
								<td style={{ width: 60 }} />
								<th>Order No. </th>
								<th>Customer</th>
								<th>Customer Phone No.</th>
								<th>Status</th>
								<th>Action</th>
							</tr>
						</thead>
						<tbody>
							{order?.map((item: any, index: any) => {
								return (
									<tr key={index}>
										<td>
											<div className='d-flex'>
												<div className='flex-grow-1'>
													<div className='fs-6 fw-bold'></div>
												</div>
											</div>
										</td>
										<td>
											<div className='d-flex'>
												<div className='flex-grow-1'>
													<div className='fs-6 fw-bold'>
														{item?.orderNo}
													</div>
												</div>
											</div>
										</td>
										<td>
											<div className='d-flex'>
												<div className='flex-grow-1'>
													<div className='fs-6 fw-bold'>
														{item?.user.name}
													</div>
												</div>
											</div>
										</td>
										<td>
											<div className='d-flex'>
												<div className='flex-grow-1'>
													<div className='fs-6 fw-bold'>
														{item?.user.phoneNumber}
													</div>
												</div>
											</div>
										</td>
										<td>{item?.status}</td>
										<td>
											<span
												onClick={() =>
													navigate('/edit/order', { state: item })
												}
												style={{ margin: 10, cursor: 'pointer' }}>
												EDIT
											</span>
											<span
												onClick={() =>
													navigate('/view/order', {
														state: { order: item },
													})
												}
												style={{ margin: 10, cursor: 'pointer' }}>
												VIEW
											</span>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
					<div
						style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
						{hasMore && (
							<button
								style={{ border: 'none', padding: '10px', borderRadius: '10px' }}
								onClick={onLoadMore}>
								Load More...
							</button>
						)}
					</div>
				</CardBody>
			</Card>
		</PageWrapper>
	);
};

export default AllOrder;
